import { StyleSheet } from 'react-native';

import { neutralGrey, warrior, white } from '../../constants/color';

const styles: any = StyleSheet.create({
  Wrapper: {
    flex: 1,
    paddingLeft: 15,
    flexDirection: 'row',
    alignItems: 'center',
    maxHeight: 50,
  },
  Checked: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    borderRadius: 3,
    margin: 0,
  },
  UnChecked: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    margin: 0,
    borderRadius: 3,
    borderStyle: 'solid',
    borderColor: neutralGrey,
    borderWidth: 1,
    backgroundColor: white,
  },
  Label: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginLeft: 6,
    fontSize: 12,
    color: warrior,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  disable: {
    opacity: 0.4,
  },
  infoField: {
    width: 20,
    height: 20,
    marginLeft: 4,
    alignItems: 'center',
  },
  labelSectionStyle: {
    flexDirection: 'row',
    display: 'flex',
  },
  labelIcon: {
    paddingLeft: 8,
  },
  labelIconEnd: {
    paddingLeft: 0,
  },
});

export default styles;
